import {React, useContext} from 'react'
import bg_img3 from './static/img/bg-img3.jpg'
import BreadcrumbsSection from './BreadcrumbsSection'
import OurServicesSection from './OurServicesSection'
import FeedbackSection from './FeedbackSection'
import RoutesContext from '../contexts/RoutesContext'

function Service5Page(props) {
    let routes_context = useContext(RoutesContext)
  return (
    <main onLoad={routes_context.flip_card_resize}>
        
        <BreadcrumbsSection routes={routes_context.routes} page_name='Services' />
        <div className="services_banner_section">
            <div className="services_banner_inner_wrapper">
                <img src={bg_img3} alt="" />
            </div>
        </div>

        <OurServicesSection routes={routes_context.routes} setCurrentPage = {routes_context.setCurrentPage} />

        <div className="content_section" id="content_section">
            <div className="content_inner_wrapper">
                <h1 className="service_content_title">DRAFT OF MAXIMUM PERMISSIBLE DISCHARGE</h1>
                <p>
                    “Sagdyn ülke” HJ DTG boýunça bölümiň işlenip düzülmegini, kärhanalary gurmak, döwrebaplaşdyrmak, durkuny täzelemek we täze kärhanalary döretmek üçin ähli ekspertizalardan geçilmegini üpjün eder.
                </p>
                <br/><br/>
                <h2>DTG BOÝUNÇA BÖLÜM NÄME?</h2>
                <p>
                    DTG boýunça bölüm – munuň özi dürli maksatly binalaryň gurluşygy we durkunyň täzelenmegi üçin düzülýän taslama degişli resminamalaryň ýörite bölüm durýar we onda obýektiň sebitdäki ekologiýanyň abadançylygyna ýetirýän täsiri beýan edilýär. Şeýle hem DTG boýunça bölümde daşky gurşawa ýaramaz täsir ýetirilýän bolsa, şol täsiriň azaldylmagyna gönükdirilen çäreleriň toplumy işlenip düzülýär.
                </p>
                <p>Şu bölüm Türkmenistanyň kadalaşdyryjy resminamalaryna laýyklykda işlenip taýýarlanýar.</p>
                <br/><br/>
                <h2>TASLAMA DEGIŞLI RESMINAMALARYŇ DTG BARADAKY BÖLÜMI IŞLENIP DÜZÜLENDE ŞULAR GÖZ ÖŇÜNDE TUTULÝAR:</h2>
                <p>
                    — Gurluşygyň barşynyň daşky gurşawa ýetirýän täsirini öwrenmek. DTG baradaky bölümi işläp düzmek gurluşygyň tehnologiýasynyň hem-de dürli tapgyrlaryň howaly, suwly gurşawyň we ýer resurslarynyň ýagdaýyna ýetirýän täsirini toplumlaýyn öwrenmekden başlanýar;
                </p>
                <p>
                    — Obýektiň ulanylmagynyň sebitdäki ekologiýanyň ýagdaýyna ýetirýän täsirini öwrenmek. Gurluşygyň döwründe, şeýle hem DTG baradaky bölüm işlenip düzülende, obýektiň mundan beýläk-de ulanylmagynyň sebitdäki ekologiýanyň ýagdaýyna ýetirýän täsiri barlanyp öwrenilýär;
                </p>
                <p>
                    — Obýektiň tebigata ýaramaz täsiriniň azaldylmagyna gönükdirilen çäreleriň sanawyny işläp düzmek. Hünärmenler sebitdäki ekologiýanyň abadançylygyna ýetirilýän zyýanly täsiriň azaldylmagyna ýa-da bütinleý aradan aýrylmagyna mümkinçilik berýän çäreleriň anyk sanawyny düzýärler;
                </p>
                <p>
                    — ENVIROMENT PROTECTION boýunça çäreleri amala aşyrmak. DTG baradaky bölümiň işlenip düzülmegi buýruja taslamanyň ekologiýa degişli düzümi boýunça zerur maýa goýumlarynyň möçberine baha bermäge mümkinçilik döreder. Taslama degişli resminamalaryň daşky tebigatyň goragyna bagyşlanan bölümde görkezilen maglumatlaryň ählisi ygtybarly bolmalydyr we hakykatdaky ýagdaýlara laýyk gelmelidir.
                </p>
                <br/><br/>
                <h2>NÄME ÜÇIN DTG BARADAKY BÖLÜMIŇ IŞLENIP DÜZÜLMEGINI “SAGDYN ÜLKE” HK TABŞYRMAK MAKUL GÖRÜLÝÄR?</h2>
                <p>
                    — <b>“Sagdyn ülke” HK</b> ekologlary belli bir kärhana üçin aýratyn (indiwidual) çözgütleri tebigaty goramak baradaky kanunçylygyň talaplaryny göz öňünde tutmak arkaly işläp düzýärler;
                </p>
                <p>
                    — <b>“Sagdyn ülke” HK</b> taslama degişli we taslamadan öňki resminamalary işläp düzýär, munuň özi ekologiýa boýunça döwlet ekspertizasyny geçirmek üçin tehnologiýanyň we esasy (prinsipial) tehniki çözgütleriň işlenip taýýarlanmagyna mümkinçilik berýär;
                </p>
                <p>— Biz bäsdeşlige mahsus bahany we işläp düzmek boýunça gysga möhletleri teklip edýäris;</p>
                <p>— Biz Servicesyň ýokary hilli ýerine ýetiriljekdigini kepillendirýäris.</p>
                <br/><br/>
                <h2 className="service_content_footer">AŞAKDA GÖRKEZILEN GÖRNÜŞDÄKI TALAPNAMANY TABŞYRYŇ ÝA-DA BIZE JAŇ EDIŇ.</h2>
            </div>
        </div>

        <FeedbackSection margin_top="margin_top" />    

    </main>
  )
}

export default Service5Page